import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/UI";


export function CountHistory() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/stock/counts").then(r => setItems(r.data)).catch(() => {}); }, []);

  // Eski kayıtlarda alan adları farklı — güvenli okuma
  const sysQty = (x) => x.system_quantity ?? x.previous_quantity ?? 0;
  const counted = (x) => x.counted_quantity ?? x.current_quantity ?? 0;
  const lossQty = (x) => x.loss_quantity ?? x.consumed_quantity ?? 0;
  const lossCost = (x) => x.loss_cost ?? x.cost ?? 0;
  const diffType = (x) => x.diff_type || (lossQty(x) > 0 ? "fire" : "tam");

  const badge = (x) => {
    const t = diffType(x);
    if (t === "fire") return <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-[#fbeee9] text-[#C45B45]">Fire</span>;
    if (t === "fazla") return <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-[#E4EEE6] text-[#2D6A4F]">Fazla</span>;
    return <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-[#F0EEE8] text-[#5e675e]">Tam</span>;
  };

  return (
    <Card className="!p-0 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="data-table" data-testid="count-history-table">
          <thead>
            <tr>
              <th>Tarih</th>
              <th>Kalem</th>
              <th className="text-right">Hesaplanan</th>
              <th className="text-right">Sayılan</th>
              <th>Durum</th>
              <th className="text-right">Fire</th>
              <th className="text-right">Zayiat Gideri (₺)</th>
              <th>Sebep</th>
              <th>Sayan Personel</th>
              <th>Notlar</th>
            </tr>
          </thead>
          <tbody>
            {items.map(x => (
              <tr key={x.id} data-testid={`count-history-row-${x.id}`}>
                <td className="tabnum">{x.date}</td>
                <td className="font-semibold">{x.stock_name}</td>
                <td className="text-right tabnum">{Number(sysQty(x)).toLocaleString("tr-TR")} {x.unit}</td>
                <td className="text-right tabnum font-semibold">{Number(counted(x)).toLocaleString("tr-TR")} {x.unit}</td>
                <td>{badge(x)}</td>
                <td className="text-right tabnum text-[#C45B45] font-semibold">
                  {diffType(x) === "fire" ? `${Number(lossQty(x)).toLocaleString("tr-TR")} ${x.unit}` : "—"}
                </td>
                <td className="text-right tabnum font-semibold">{diffType(x) === "fire" ? Number(lossCost(x)).toLocaleString("tr-TR") : "—"}</td>
                <td className="text-sm text-[#5e675e]">{x.loss_reason || "—"}</td>
                <td className="text-sm text-[#5e675e]">{x.created_by || "—"}</td>
                <td className="text-sm text-[#5e675e]">{x.notes || "—"}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={10} className="text-center py-10 text-[#8a938c]">Henüz sayım kaydı yok. Stok kalemlerinde 🔍 (Sayım) ikonuyla mutabakat yapın.</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
